module.exports = __webpack_public_path__ + "static/aloopalert-938fd52fb6a41254f42e9e3811a3fbd6.png";